export const addRegister = (id, email, userName, profile_pic) => {
  return {
    type: "user/register",
    payload: {
      id,
      email,
      userName,
      profile_pic,
    },
  };
};
